import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import {
  IQRAScenario,
  IStringAttributeDetails,
  type IStringAttributeOptions
} from './types'

export interface IAttributeOption {
  id: string
  code: string
  name: string
  dataType: string
}

interface IWhatIfScenarioState {
  stringAttributeCode: string
  selectedThreatId: string
  selectedScenario: IQRAScenario
  stringAttributeDetails: IStringAttributeDetails[]
}

const initialState: IWhatIfScenarioState = {
  selectedThreatId: '',
  stringAttributeCode: '',
  selectedScenario: {
    id: 0,
    name: '',
    rules: []
  },
  stringAttributeDetails: []
}

export const whatIfScenarioSlice = createSlice({
  name: 'what-if-scenario',
  initialState,
  reducers: {
    setSelectedThreatId: (state, action: PayloadAction<string>) => {
      state.selectedThreatId = action.payload
    },
    setSelectedScenario: (state, action: PayloadAction<IQRAScenario>) => {
      state.selectedScenario = action.payload
    },
    setStringAttributeOptions: (
      state,
      action: PayloadAction<IStringAttributeOptions[]>
    ) => {
      const stringAttributeOptions = action.payload

      if (
        !state.stringAttributeDetails.some(
          (i: IStringAttributeDetails) => i.code === state.stringAttributeCode
        )
      ) {
        state.stringAttributeDetails.push({
          code: state.stringAttributeCode,
          options: stringAttributeOptions
        })
      }
    },
    setStringAttributeCode: (state, action: PayloadAction<string>) => {
      state.stringAttributeCode = action.payload
    }
  }
})

export const {
  setSelectedThreatId: setSelectedThreatIdSync,
  setSelectedScenario: setSelectedScenarioSync,
  setStringAttributeOptions: setStringAttributeOptionsSync,
  setStringAttributeCode
} = whatIfScenarioSlice.actions

export default whatIfScenarioSlice.reducer
